export enum MutationTypes {
    SET_IS_MOBILE = 'SET_IS_MOBILE',
}